__turbopack_context__.v({
  "modalRoot": "GlpSignUpTypeformModal-module__SAaqWW__modalRoot",
  "typeformContainer": "GlpSignUpTypeformModal-module__SAaqWW__typeformContainer",
});
